import { CHANGE_A } from "./openChatActions";
import { CHANGE_B } from "./openChatActions";
import { CHANGE_C } from "./openChatActions";
import { CHANGE_D } from "./openChatActions";


const INITIAL_STATE = {
  openMessage: false,
  openMessageHeader: false,
  messages: [],
  openWithSocket: true,
};

const openChatReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CHANGE_A:
      return {
        ...state,
        openMessage: !state.openMessage
      };
    case CHANGE_B:
      return {
        ...state,
        openMessageHeader: !state.openMessageHeader
      };
    
    case CHANGE_C: 
    return {
      ...state,
      messages: [...state.messages, action.payload]
    };

    case CHANGE_D: 
    return {
      ...state,
      openWithSocket: action.payload
    };



    default:
      return state;
  }
};

export default openChatReducer;
